module.exports = __webpack_public_path__ + "public/img/Mengolah Data Penjualan dengan Microsoft Excel untuk Menjadi Admin Input Data.7a317ddf.png";